export function session_set(name, data) {
  sessionStorage.setItem(name, JSON.stringify(data));
}

export function session_get(name) {
  return JSON.parse(sessionStorage.getItem(name));
}

export function local_set(name, data) {
  localStorage.setItem(name, JSON.stringify(data));
}

export function local_get(name) {
  return JSON.parse(localStorage.getItem(name));
}

export function isMobile(str) {
  let num = typeof str === 'string' ? Number(str) : str;
  let filter = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
  return filter.test(num);
}